import req from "../http";

const menu = {
  // 取得 選單
  getMenu(params) {
    return req("get", "/auth/menu", params);
  },

  // 新增 選單
  postMenu(params) {
    return req("post", "/auth/menu", params);
  },

  // 編輯 選單
  putMenu(params) {
    return req("put", "/auth/menu", params);
  },

  // 刪除 選單
  deleteMenu(guid) {
    return req("delete", `/auth/menu/${guid}`);
  },

  // 排序 選單
  sortMenu(params) {
    return req("post", "/auth/menu/sort", params);
  },

  // 設定 選單多國語系
  setMenuLocalization(params) {
    return req("post", "/auth/LocalizationalMenu", params);
  }
};

export default menu;